// TradingView watchlist formatting with per-market symbol prefixes.
//
// A market's prefix config comes from GET /markets/{code}/prefixes:
//   { default: "BIST" | null, symbols: { AAPL: "NASDAQ", XOM: "NYSE" } }
// - default: applied to every symbol in that market (BIST:AKBNK)
// - null default + symbol map: per-symbol prefixes (NASDAQ:AAPL)
// - null default + no map: bare symbols (EURUSD, XAUUSD, BTC)

export const formatSymbol = (code, prefixes) => {
  if (!prefixes) return code;
  const perSymbol = prefixes.symbols && prefixes.symbols[code];
  if (perSymbol) return `${perSymbol}:${code}`;
  if (prefixes.default) return `${prefixes.default}:${code}`;
  return code;
};

export const formatWatchlist = (exchangeCode, stocks, prefixes) => {
  return (
    `###${exchangeCode}, ` + stocks.map((s) => formatSymbol(s.code, prefixes)).join(", ")
  );
};
